import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Subscription, SubscriptionResponseDTO } from './subscription.model';
import { Invoice } from '../../../models/invoice.model';

@Injectable()
export class SubscriptionService {
  private http = inject(HttpClient);


  private baseUrl = environment.host;

  getAll(page: number, limit = 10) {
    return this.http.get<SubscriptionResponseDTO>(
      this.baseUrl + '/api/v1/subscription?page=' + page + '&limit=' + limit
    );
  }

  fetchAllSubscribtions() {
    return this.http.get<Subscription[]>(
      this.baseUrl + '/api/v1/subscription/fetch-all'
    );
  }

  // TODO: should change when invoice are created for orders
  fetchAllInvoices() {
    return this.http.get<Invoice[]>(
      this.baseUrl + '/api/v1/subscription/fetch-all-invoices'
    );
  }

  fetchInvoice(invoiceId: string) {
    return this.http.get<Invoice>(
      this.baseUrl + '/api/v1/invoice/' + invoiceId
    );
  }

  downloadInvoice(invoiceId: string) {
    return this.http.get(
      this.baseUrl + '/api/v1/invoice/' + invoiceId + '/download',
      { responseType: 'blob' }
    );
  }

  cancelSubscription(id: string) {
    return this.http.put<any>(
      this.baseUrl + '/api/v1/subscription/' + id + '/cancel-request',
      {}
    );
  }

  removeCancelRequest(id: string) {
    return this.http.put<any>(
      this.baseUrl + '/api/v1/subscription/' + id + '/cancel-request/remove',
      {}
    );
  }

  activateSubscription(id: string) {
    return this.http.put<any>(
      this.baseUrl + '/api/v1/subscription/' + id + '/activate',
      {}
    );
  }

  markSubscriptionAsOverDue(id: string) {
    return this.http.put<any>(
      this.baseUrl + '/api/v1/subscription/' + id + '/markAsOverdue',
      {}
    );
  }

  generateInvoice(id: string) {
    return this.http.post<Invoice>(
      this.baseUrl + '/api/v1/subscription/' + id + '/invoice',
      {}
    );
  }

  suspendSubscription(id: string) {
    return this.http.put<any>(
      this.baseUrl + '/api/v1/subscription/' + id + '/suspend',
      {}
    );
  }

  forceCancelSubscription(id: string) {
    return this.http.put<any>(
      this.baseUrl + '/api/v1/subscription/' + id + '/cancel',
      {}
    );
  }

  assignSubscription(payload: {
    liveClass: string;
    user: string;
    paymentType?: string;
  }) {
    return this.http.post<any>(
      this.baseUrl + '/api/v1/subscription',
      payload
    );
  }
}
